import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useAusenciasOutletContext } from 'pages/Ausencias.context'
import { useParams } from 'react-router-dom'
import {
    ErrorHandler,
    abonos,
    afastamento,
    ajustes,
    compensacaoFeriados,
    compensacaoFolgas,
} from 'service/api'
import { faltasCadastradas } from 'service/api/endpoints/faltas-cadastradas'
import { toast } from 'sonner'
import { useStore } from 'store'
import { match } from 'ts-pattern'
import { tipoAusenciaToPermission } from '../Opcoes'
import IconeCadeado from './IconeCadeado'
import invalidateAusenciasQuery from './invalidateAusenciasQuery'

export default function ExcluirAusencia() {
    const empresa = useStore(state => state.company)
    const { data, competencia } = useAusenciasOutletContext()
    const { id, tipo } = useParams() as { id: string; tipo: string }
    const isEdicaoBloqueada = empresa?.competenciaAtual !== competencia

    const tipoFormatado = match(tipo)
        .with('afastamento', () => 'Afastamento')
        .with('abono', () => 'Abono')
        .with('compensacao-feriado', () => 'Compensação de feriado')
        .with('compensacao-folga', () => 'Compensação de folga')
        .with('falta-injustificada', () => 'Falta injustificada')
        .with('falta-justificada', () => 'Falta justificada')
        .otherwise(() => 'Ocorrência')

    const options = {
        onSuccess: async () => {
            await ajustes.aprovados.invalidateQueries()
            await ajustes.relatorioAusencias.invalidateQueries()
            toast.success(`${tipoFormatado} excluído(a) com sucesso`)
        },
        onError: (e: ErrorHandler) => {
            toast.error(e.message)
        },
    }

    const { mutateAsync: excluirAfastamento, isLoading: lAf } =
        afastamento.mutations.useSoftDelete({ invalidateQuery: true })
    const { mutateAsync: excluirAbono, isLoading: lAb } =
        abonos.mutations.useSoftDelete({ invalidateQuery: true })
    const { mutateAsync: excluirCompensacaoFeriado, isLoading: lC } =
        compensacaoFeriados.mutations.useSoftDelete({ invalidateQuery: true })
    const { mutateAsync: excluirCompensacaoFolga, isLoading: lCF } =
        compensacaoFolgas.mutations.useSoftDelete({ invalidateQuery: true })
    const { mutateAsync: excluirFalta, isLoading: lF } =
        faltasCadastradas.mutations.useSoftDelete({ invalidateQuery: true })

    const row = data?.find(a => a.id === tipo + '_' + id)
    if (!empresa || !data || !row) return null

    async function handleSubmit({ motivo }: { motivo: string }) {
        if (!empresa) return
        const variables = {
            id,
            motivo,
            empresaId: empresa.id,
        } as any

        switch (tipo) {
            case 'afastamento':
                return excluirAfastamento(variables, options)
            case 'abono':
                return excluirAbono(variables, options)
            case 'compensacao-feriado':
                return excluirCompensacaoFeriado(variables, options)
            case 'compensacao-folga':
                return excluirCompensacaoFolga(variables, options)
            case 'falta-injustificada':
            case 'falta-justificada':
                return excluirFalta(variables, options)
            default:
                throw new Error(`Tipo de ausência ${tipo} desconhecido`)
        }
    }

    return (
        <ConfirmarExclusao
            width="2xl"
            permissao={['delete', tipoAusenciaToPermission(tipo)]}
            loading={lAf || lAb || lC || lCF || lF}
            exigirMotivo
            desabilitado={isEdicaoBloqueada}
            onConfirm={props =>
                handleSubmit(props as { motivo: string }).then(() =>
                    invalidateAusenciasQuery(),
                )
            }
            title={
                <>
                    Tem certeza que deseja excluir o(a) {tipoFormatado}?
                    {isEdicaoBloqueada && <IconeCadeado />}
                </>
            }
        />
    )
}
